<template>
  <div>
    <div class="page-header clear-filter" filter-color="skyblue">
      <parallax
        class="page-header-image"
        style="background-image:url('img/header.jpg')"
      >
      </parallax>
      <div class="container">
        <div class="content-center brand">
          <h1 class="h1-seo">Security.</h1>
          <h1 class="h1-seo">Media.</h1>
          <h3>Welcome To My Online Place.</h3>
        </div>
      </div>
    </div>
    <main class="portfolio-index">
      <section class="section index-intro-section">
        <div class="container">
          <div class="row align-items-center">
            <div class="col-lg-6">
              <p class="index-eyebrow">SPAREONE PORTFOLIO</p>
              <h2 class="title">SPAREONE 작업실</h2>
              <p class="description index-lead">
                프로젝트 정리 공간
              </p>
              <div class="index-actions">
                <router-link
                  :to="{ name: 'tech' }"
                  class="btn btn-info btn-round"
                >
                  Technical Projects
                </router-link>
                <router-link
                  :to="{ name: 'media' }"
                  class="btn btn-outline-info btn-round"
                >
                  Media Contents
                </router-link>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="index-highlight-panel">
                <div
                  v-for="stat in stats"
                  :key="stat.label"
                  class="index-stat"
                >
                  <strong>{{ stat.value }}</strong>
                  <span>{{ stat.label }}</span>
                </div>
              </div>
              <div class="index-focus-list">
                <div
                  v-for="focus in focusItems"
                  :key="focus.title"
                  class="index-focus-item"
                >
                  <i :class="focus.icon"></i>
                  <div>
                    <h3>{{ focus.title }}</h3>
                    <p>{{ focus.description }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="section index-links-section">
        <div class="container">
          <div class="section-heading text-center">
            <p class="index-eyebrow">EXPLORE</p>
            <h2 class="title">둘러보기</h2>
          </div>
          <div class="row">
            <div
              v-for="section in portfolioSections"
              :key="section.title"
              class="col-lg-4 col-md-6"
            >
              <router-link :to="{ name: section.route }" class="index-card-link">
                <article class="index-card">
                  <div
                    class="index-card-cover"
                    :style="{ backgroundImage: `url('${section.image}')` }"
                  >
                    <span>{{ section.label }}</span>
                  </div>
                  <div class="index-card-body">
                    <h3>{{ section.title }}</h3>
                    <p>{{ section.description }}</p>
                    <div class="index-card-more">
                      <span>{{ section.linkText }}</span>
                      <i class="now-ui-icons arrows-1_minimal-right"></i>
                    </div>
                  </div>
                </article>
              </router-link>
            </div>
          </div>
        </div>
      </section>

      <section class="section index-featured-section">
        <div class="container">
          <div class="row align-items-start">
            <div class="col-lg-5">
              <p class="index-eyebrow">FEATURED</p>
              <h2 class="title">최근 작업</h2>
              <p class="description">
                최신 작업물
              </p>
            </div>
            <div class="col-lg-7">
              <div class="featured-list">
                <router-link
                  v-if="featuredProject"
                  :to="{
                    name: 'tech-detail',
                    params: { slug: featuredProject.slug }
                  }"
                  class="featured-item"
                >
                  <span class="featured-type">Tech</span>
                  <div>
                    <h3>{{ featuredProject.title }}</h3>
                    <p>{{ featuredProject.summary }}</p>
                  </div>
                </router-link>
                <a
                  v-if="featuredVideo"
                  :href="featuredVideo.url"
                  target="_blank"
                  rel="noopener"
                  class="featured-item"
                >
                  <span class="featured-type">Media</span>
                  <div>
                    <h3>{{ featuredVideo.title }}</h3>
                    <p>{{ featuredVideo.description }}</p>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="section index-gallery-section">
        <div class="container">
          <div class="recent-photo-heading">
            <p class="index-eyebrow">RECENT PHOTOS</p>
            <h2 class="title">최근 사진</h2>
          </div>
          <div class="recent-photo-carousel">
            <el-carousel height="520px">
              <el-carousel-item
                v-for="photo in recentPhotos"
                :key="photo.id"
              >
                <router-link
                  :to="{
                    name: 'gallery',
                    query: { v: 'album', a: photo.albumId }
                  }"
                  class="recent-photo-slide"
                >
                  <img :src="photo.image" :alt="photo.title" />
                  <span class="recent-photo-caption">
                    <span>{{ photo.albumTitle }}</span>
                    <strong>{{ photo.title }}</strong>
                    <small>{{ photo.takenAt }} · {{ photo.location }}</small>
                  </span>
                </router-link>
              </el-carousel-item>
            </el-carousel>
          </div>
          <div class="recent-photo-actions">
            <router-link
              :to="{ name: 'gallery', query: { v: 'album' } }"
              class="btn btn-info btn-round"
            >
              갤러리 보기
            </router-link>
          </div>
        </div>
      </section>

      <section class="section index-social-section">
        <div class="container">
          <div class="section-heading text-center">
            <p class="index-eyebrow">CONNECT</p>
            <h2 class="title">SNS & Links</h2>
          </div>
          <div class="row justify-content-center">
            <div
              v-for="link in socialLinks"
              :key="link.title"
              class="col-lg-3 col-md-6"
            >
              <a
                :href="link.url"
                target="_blank"
                rel="noopener"
                class="social-card"
              >
                <span class="social-icon">
                  <span
                    v-if="link.logoClass"
                    class="social-logo-mask"
                    :class="link.logoClass"
                  ></span>
                  <i v-else :class="link.icon"></i>
                </span>
                <strong>{{ link.title }}</strong>
                <span>{{ link.description }}</span>
              </a>
            </div>
          </div>
        </div>
      </section>
    </main>
  </div>
</template>
<script>
import { Carousel, CarouselItem } from 'element-ui';
import { Parallax } from '@/components';
import galleryAlbums from './gallery/data';
import mediaItems from './portfolio/media/data';
import techProjects from './portfolio/tech/data';

export default {
  name: 'index',
  bodyClass: 'index-page',
  components: {
    [Carousel.name]: Carousel,
    [CarouselItem.name]: CarouselItem,
    Parallax
  },
  data() {
    return {
      stats: [
        {
          value: `${techProjects.length}+`,
          label: 'Technical Projects'
        },
        {
          value: `${mediaItems.length}+`,
          label: 'Media Contents'
        },
        {
          value: 'Security',
          label: 'Main Track'
        }
      ],
      focusItems: [
        {
          icon: 'now-ui-icons tech_laptop',
          title: 'IT Technical Projects',
          description:
            '개발 및 정보보호'
        },
        {
          icon: 'now-ui-icons media-1_button-play',
          title: 'Media Production',
          description:
            '영상 미디어 컨텐츠 제작'
        }
      ],
      portfolioSections: [
        {
          route: 'profile',
          image: 'img/profile.jpg',
          label: 'Profile',
          title: 'Profile',
          description:
            'SPAREONE 프로필',
          linkText: '프로필 보기'
        },
        {
          route: 'tech',
          image: 'img/tech.jpg',
          label: 'Tech',
          title: 'Technical Projects',
          description:
            '진행한 프로젝트',
          linkText: '프로젝트 보기'
        },
        {
          route: 'media',
          image: 'img/media.jpg',
          label: 'Media',
          title: 'Media Contents',
          description:
            '제작한 영상 컨텐츠',
          linkText: '콘텐츠 보기'
        }
      ],
      socialLinks: [
        {
          title: 'Tistory Blog',
          description: '기술 블로그',
          logoClass: 'social-logo-tistory',
          url: 'https://blog.spareone.io'
        },
        {
          title: 'Naver Blog',
          description: '글쓰기 블로그',
          logoClass: 'social-logo-naver-blog',
          url: 'https://blog.naver.com/spareone1'
        },
        {
          title: 'YouTube',
          description: '영상 콘텐츠',
          icon: 'fab fa-youtube',
          url: 'https://www.youtube.com/@ChangHyeon'
        },
        {
          title: 'GitHub',
          description: '코드 저장소',
          icon: 'fab fa-github',
          url: 'https://github.com/spareone1'
        }
      ]
    };
  },
  computed: {
    featuredProject() {
      return techProjects[0];
    },
    featuredVideo() {
      return mediaItems[0];
    },
    recentPhotos() {
      return galleryAlbums
        .reduce((photos, album) => {
          const albumPhotos = album.photos.map(photo => ({
            ...photo,
            albumId: album.id,
            albumTitle: album.title
          }));

          return photos.concat(albumPhotos);
        }, [])
        .sort((a, b) => b.takenAt.localeCompare(a.takenAt))
        .slice(0, 5);
    }
  }
};
</script>
<style scoped>
.portfolio-index {
  background: #f8fafc;
}

.index-intro-section {
  padding: 80px 0 70px;
}

.index-eyebrow {
  margin-bottom: 12px;
  color: #2ca8ff;
  font-size: 0.82rem;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
}

.index-lead {
  max-width: 620px;
  line-height: 1.8;
}

.index-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 28px;
}

.index-actions .btn {
  margin: 0;
}

.btn-outline-info {
  border: 1px solid #2ca8ff;
  background: transparent;
  color: #1683d8;
}

.btn-outline-info:hover,
.btn-outline-info:focus {
  background: #2ca8ff;
  color: #fff;
}

.index-highlight-panel {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
  margin-bottom: 18px;
}

.index-stat {
  min-height: 116px;
  padding: 22px 16px;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 18px 42px rgba(15, 23, 42, 0.08);
  text-align: center;
}

.index-stat strong {
  display: block;
  color: #1f2937;
  font-size: 1.45rem;
  line-height: 1.2;
}

.index-stat span {
  display: block;
  margin-top: 9px;
  color: #64748b;
  font-size: 0.82rem;
  font-weight: 600;
}

.index-focus-list {
  display: grid;
  gap: 14px;
}

.index-focus-item {
  display: flex;
  gap: 16px;
  padding: 22px;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 18px 42px rgba(15, 23, 42, 0.08);
}

.index-focus-item i {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  flex: 0 0 42px;
  border-radius: 50%;
  background: rgba(44, 168, 255, 0.12);
  color: #2ca8ff;
  font-size: 1.15rem;
}

.index-focus-item h3,
.index-card-body h3,
.featured-item h3 {
  margin-top: 0;
}

.index-focus-item h3 {
  margin-bottom: 8px;
  font-size: 1.15rem;
}

.index-focus-item p {
  margin-bottom: 0;
  color: #64748b;
  line-height: 1.7;
}

.index-links-section {
  padding: 70px 0;
  background: #fff;
}

.section-heading {
  margin-bottom: 34px;
}

.index-card-link {
  display: block;
  height: 100%;
  color: inherit;
}

.index-card-link:hover,
.index-card-link:focus {
  color: inherit;
  text-decoration: none;
}

.index-card {
  display: flex;
  height: 100%;
  overflow: hidden;
  flex-direction: column;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 20px 45px rgba(44, 62, 80, 0.12);
  transition:
    transform 0.2s ease,
    box-shadow 0.2s ease;
}

.index-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 24px 54px rgba(44, 62, 80, 0.18);
}

.index-card-cover {
  position: relative;
  min-height: 210px;
  background-position: center;
  background-size: cover;
}

.index-card-cover::before {
  content: '';
  position: absolute;
  inset: 0;
  background: linear-gradient(
    180deg,
    rgba(15, 23, 42, 0.08) 0%,
    rgba(15, 23, 42, 0.78) 100%
  );
}

.index-card-cover span {
  position: absolute;
  right: 20px;
  bottom: 18px;
  z-index: 1;
  color: #fff;
  font-size: 0.86rem;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
}

.index-card-body {
  display: flex;
  flex: 1;
  flex-direction: column;
  padding: 24px;
}

.index-card-body h3 {
  margin-bottom: 12px;
  font-size: 1.35rem;
}

.index-card-body p {
  margin-bottom: 22px;
  color: #64748b;
  line-height: 1.7;
}

.index-card-more {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: auto;
  color: #1683d8;
  font-weight: 700;
}

.index-featured-section {
  padding: 70px 0 86px;
}

.index-gallery-section {
  padding: 70px 0 86px;
  background: #fff;
}

.index-social-section {
  padding: 70px 0 86px;
}

.recent-photo-heading {
  margin-bottom: 26px;
  text-align: center;
}

.recent-photo-heading .title {
  margin-bottom: 0;
}

.featured-list {
  display: grid;
  gap: 16px;
}

.featured-item {
  display: grid;
  grid-template-columns: 92px minmax(0, 1fr);
  gap: 18px;
  padding: 24px;
  border-radius: 8px;
  background: #fff;
  color: inherit;
  box-shadow: 0 18px 42px rgba(15, 23, 42, 0.08);
  transition:
    transform 0.2s ease,
    box-shadow 0.2s ease;
}

.featured-item:hover,
.featured-item:focus {
  color: inherit;
  text-decoration: none;
  transform: translateY(-4px);
  box-shadow: 0 22px 48px rgba(15, 23, 42, 0.12);
}

.featured-type {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 34px;
  border-radius: 999px;
  background: rgba(44, 168, 255, 0.12);
  color: #1683d8;
  font-size: 0.78rem;
  font-weight: 700;
  text-transform: uppercase;
}

.featured-item h3 {
  margin-bottom: 8px;
  font-size: 1.2rem;
}

.featured-item p {
  margin-bottom: 0;
  color: #64748b;
  line-height: 1.65;
  white-space: pre-line;
}

.recent-photo-carousel {
  position: relative;
  overflow: hidden;
  border-radius: 8px;
  background: #111;
  box-shadow: 0 24px 54px rgba(15, 23, 42, 0.16);
}

.recent-photo-actions {
  margin-top: 28px;
  text-align: center;
}

.recent-photo-actions .btn {
  margin: 0;
}

.recent-photo-slide {
  position: relative;
  display: block;
  height: 100%;
  color: #fff;
}

.recent-photo-slide:hover,
.recent-photo-slide:focus {
  color: #fff;
  text-decoration: none;
}

.recent-photo-slide::after {
  content: '';
  position: absolute;
  inset: 0;
  background: linear-gradient(
    180deg,
    rgba(15, 23, 42, 0.02) 0%,
    rgba(15, 23, 42, 0.18) 45%,
    rgba(15, 23, 42, 0.78) 100%
  );
}

.recent-photo-slide img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.recent-photo-caption {
  position: absolute;
  right: 28px;
  bottom: 54px;
  left: 28px;
  z-index: 1;
  display: grid;
  gap: 6px;
}

.recent-photo-caption span {
  font-size: 0.78rem;
  font-weight: 800;
  letter-spacing: 0.1em;
  text-transform: uppercase;
}

.recent-photo-caption strong {
  font-size: 1.55rem;
  line-height: 1.25;
}

.recent-photo-caption small {
  color: rgba(255, 255, 255, 0.78);
  font-weight: 700;
}

:deep(.recent-photo-carousel .el-carousel__indicators) {
  right: auto;
  bottom: 22px;
  left: 50%;
  width: auto;
  transform: translateX(-50%);
}

:deep(.recent-photo-carousel .el-carousel__indicator) {
  padding: 0 4px;
}

:deep(.recent-photo-carousel .el-carousel__button) {
  width: 26px;
  height: 3px;
  border-radius: 999px;
  background-color: rgba(255, 255, 255, 0.72);
  opacity: 1;
}

:deep(.recent-photo-carousel .el-carousel__indicator.is-active .el-carousel__button) {
  background-color: #fff;
}

.social-card {
  display: flex;
  min-height: 190px;
  margin-bottom: 28px;
  padding: 28px 22px;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  border-radius: 8px;
  background: #f8fafc;
  color: inherit;
  box-shadow: inset 0 0 0 1px rgba(15, 23, 42, 0.07);
  text-align: center;
  transition:
    transform 0.2s ease,
    box-shadow 0.2s ease,
    background-color 0.2s ease;
}

.social-card:hover,
.social-card:focus {
  background: #fff;
  color: inherit;
  text-decoration: none;
  transform: translateY(-5px);
  box-shadow:
    inset 0 0 0 1px rgba(44, 168, 255, 0.18),
    0 22px 48px rgba(15, 23, 42, 0.1);
}

.social-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 54px;
  height: 54px;
  margin-bottom: 18px;
  border-radius: 50%;
  background: rgba(44, 168, 255, 0.12);
  color: #1683d8;
  font-size: 1.35rem;
}

.social-logo-mask {
  display: block;
  width: 28px;
  height: 28px;
  background-color: #1683d8;
  mask-position: center;
  mask-repeat: no-repeat;
  mask-size: contain;
  -webkit-mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-size: contain;
}

.social-logo-naver-blog {
  width: 34px;
  height: 34px;
}

.social-logo-tistory {
  mask-image: url('/img/social/tistory-icon.svg');
  -webkit-mask-image: url('/img/social/tistory-icon.svg');
}

.social-logo-naver-blog {
  mask-image: url('/img/social/naver-blog-icon.svg');
  -webkit-mask-image: url('/img/social/naver-blog-icon.svg');
}

.social-card strong {
  display: block;
  margin-bottom: 8px;
  color: #1f2937;
  font-size: 1.08rem;
}

.social-card span:last-child {
  color: #64748b;
  font-size: 0.92rem;
  font-weight: 600;
}

@media (max-width: 991px) {
  .index-highlight-panel {
    margin-top: 34px;
  }

  .index-links-section .col-lg-4 {
    margin-bottom: 28px;
  }

}

@media (max-width: 767px) {
  .index-intro-section,
  .index-links-section,
  .index-featured-section,
  .index-gallery-section,
  .index-social-section {
    padding: 56px 0;
  }

  .index-highlight-panel {
    grid-template-columns: 1fr;
  }

  .index-focus-item,
  .featured-item {
    grid-template-columns: 1fr;
  }

  .featured-item {
    display: block;
  }

  .featured-type {
    margin-bottom: 14px;
    padding: 0 14px;
  }

  .recent-photo-caption {
    right: 20px;
    bottom: 48px;
    left: 20px;
  }

  .recent-photo-caption strong {
    font-size: 1.25rem;
  }
}
</style>
